import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationExtras, Router, RoutesRecognized } from '@angular/router';
import { filter, map } from 'rxjs';
import { Stack } from '../utility/stack'

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  urls = new Stack<RoutesRecognized>()

  ignoreNext = false;

  get previousRoute() {
    return this.urls.peek(2)
  }

  get currentRoute() {
    return this.urls.peek()
  }

  constructor(
    private router: Router,
    private location: Location
  ) {

    this.location.subscribe(state => {
      if (state.type === "popstate") {

        this.urls.pop() //remove current route
        this.urls.pop() //previous route
      }
    })

    this.router.events.pipe(
      filter((event) => event instanceof RoutesRecognized),
      map((event) => event as RoutesRecognized)

    )
      .subscribe(event => {
        const extras = this.router.getCurrentNavigation()?.extras
        
        if (!this.ignoreNext && !extras?.skipLocationChange) {
          this.urls.push(event)
        }

        this.ignoreNext = false

      })
  }

  canGoBack() {
    return this.urls.size() > 1
  }

  back() {
this.router.setUpLocationChangeListener()
    this.urls.pop() //remove current route
    const route = this.urls.pop() //previous route

    if (route) {
      this.ignoreNext = true;
      this.router.navigateByUrl(route.url)
      this.location.back()
    }

  }

  navigate(commands: any[], extras?: NavigationExtras) {
    if (extras?.skipLocationChange) {
      this.ignoreNext = true;
    }
    this.router.navigate(commands, extras)
  }

}
